import React, { useState } from 'react';
import { Box, TextField, InputAdornment, MenuItem } from '@mui/material';
import { darkFieldSx } from './darkFieldStyles';

function PhoneNumberInputLogin({ data, name, setData, handleSubmit, id, value, onBlur, onChange, error, helperText, formik, dark }) {
  const [countryCode, setCountryCode] = useState(data?.country_code || '+1');

  const handleCountryCodeChange = (event) => {
    formik.setFieldValue('country_code', event.target.value);
    setCountryCode(event.target.value);
  };

  return (
    <TextField
      id={id}
      variant="outlined"
      fullWidth
      type="tel"
      name={name}
      required
      value={value || ''}
      placeholder="Phone number"
      autoComplete="tel-national"
      sx={{ my: '5px', ...(dark ? darkFieldSx : {}) }}
      onChange={onChange}
      onBlur={onBlur}
      helperText={helperText}
      error={error}
      inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', style: { fontSize: 18, color: dark ? '#fff' : undefined } }}
      InputProps={{
        sx: { height: dark ? 48 : 45, fontSize: 18 },
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 0 }}>
            <TextField
              select
              value={countryCode}
              onChange={handleCountryCodeChange}
              variant="standard"
              autoComplete="tel-country-code"
              sx={dark ? {
                minWidth: 56,
                '& .MuiInput-root': { color: '#fff' },
                '& .MuiSelect-select': { color: '#fff', fontSize: 18, py: 0.5 },
                '& .MuiSvgIcon-root': { color: 'rgba(255,255,255,0.7)' },
                '&::before, &::after': { borderColor: 'rgba(255,255,255,0.35)' },
              } : { minWidth: 56 }}
            >
              <MenuItem value="+1">+1</MenuItem>
              <MenuItem value="+44">+44</MenuItem>
              <MenuItem value="+86">+86</MenuItem>
              <MenuItem value="+91">+91</MenuItem>
              <MenuItem value="+55">+55</MenuItem>
              <MenuItem value="+81">+81</MenuItem>
              <MenuItem value="+90">+90</MenuItem>
              <MenuItem value="+48">+48</MenuItem>
              <MenuItem value="+420">+420</MenuItem>
              <MenuItem value="+351">+351</MenuItem>
              <MenuItem value="+34">+34</MenuItem>
            </TextField>
            {dark && (
              <Box sx={{ width: '1px', height: 28, bgcolor: 'rgba(255,255,255,0.25)', mx: 1 }} />
            )}
          </InputAdornment>
        ),
      }}
    />
  );
}

export default PhoneNumberInputLogin;
